import { HTMLAttributes } from 'react';

type BadgeVariant = 'primary' | 'success' | 'warning' | 'danger' | 'info';

interface BadgeProps extends HTMLAttributes<HTMLSpanElement> {
	variant?: BadgeVariant;
	children: React.ReactNode;
}

const Badge = ({ variant = 'primary', className = '', children, ...props }: BadgeProps) => {
	const variantClasses = {
		primary: 'bg-indigo-100 dark:bg-indigo-900/30 text-blue-700 dark:text-blue-300',
		success: 'bg-green-100 dark:bg-green-900/30 text-green-700 dark:text-green-300',
		warning: 'bg-yellow-100 dark:bg-yellow-900/30 text-yellow-700 dark:text-yellow-300',
		danger: 'bg-red-100 dark:bg-red-900/30 text-red-700 dark:text-red-300',
		info: 'bg-blue-100 dark:bg-blue-900/30 text-blue-700 dark:text-blue-300',
	};

	return (
		<span
			className={`inline-block px-2.5 py-1.5 rounded-full text-xs font-semibold transition-colors ${variantClasses[variant]} ${className}`}
			{...props}
		>
			{children}
		</span>
	);
};

export default Badge;
